import { AxiosPromise } from 'axios';
import { client }       from '@/service/client';

export const getAllQuotes = (): AxiosPromise => client.post('/reports/group-quotation', {
  filterForm: {},
});
